import { Link } from 'react-router-dom';
import { listEnabledGames } from '../../registry';

/**
 * The catalogue reads the registry only. It never imports a game module — modules load when
 * a game is launched, so future titles cannot inflate Spider Math's startup (architecture §8).
 */
export function CataloguePage() {
  const games = listEnabledGames();

  return (
    <section>
      <h1>Games</h1>
      <p className="lede">Pick a game to play together.</p>

      {games.length === 0 ? (
        <p className="notice">No games are switched on yet.</p>
      ) : (
        <ul className="card-grid" data-testid="game-catalogue">
          {games.map((game) => (
            <li key={game.id} className="panel" data-game-id={game.id}>
              <h2 style={{ marginTop: 0 }}>{game.title}</h2>
              {game.tagline === undefined ? null : <p className="lede">{game.tagline}</p>}
              {game.featured === true ? <span className="badge">Featured</span> : null}
              <p>
                {/* Setup first: a grown-up sets the session's shape before a child sees the
                    stage (game design spec §11). Continuing an interrupted mission from Home
                    goes straight to /play, because its shape was already chosen. */}
                <Link to={`/play/${game.id}/setup`} className="button">
                  Start {game.title}
                </Link>
              </p>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
